export default `
... on Homepage_Homepagebuilder_rows_Content_ContentBreaker {
   fieldGroupName
   image {
      sourceUrl
      altText
   }
}`;
